import { Inject, Injectable, Optional } from '@angular/core';
import { from, Observable, Subscription } from 'rxjs';
import { FirebaseApp } from '@angular/fire/app';
import { getToken, Messaging, onMessage } from '@angular/fire/messaging';
import { HttpClient } from '@angular/common/http';
import { GetTokenOptions } from '@firebase/messaging';
import { FirebaseNotificationServiceFacade } from './firebase-notification.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
    providedIn: 'root'
})
export class WebNotificationService extends FirebaseNotificationServiceFacade {
    tokenSubscription$: Subscription;

    constructor(
        @Optional() private app: FirebaseApp,
        @Optional() private messaging: Messaging,
        @Inject('ENV') env: any,
        http: HttpClient
    ) {
        super(env, http);
    }

    initialize(): void {
        if (Capacitor.getPlatform() !== 'web') {
            throw new Error('This Firebase service is only meant for web');
        }

        this.registerFcmSdkToken();
        this.addNotificationListener();
    }

    registerFcmSdkToken(): void {
        if (this.messaging) {
            // Firebase Cloud Messaging (FCM) requires a firebase-messaging-sw.js file in order to work.
            // Add blank one or filled with necessary functionality
            // Ref: https://firebase.google.com/docs/cloud-messaging/js/client#access_the_registration_token
            this.tokenSubscription$ = this.getRegisterFcmSdkToken().subscribe((token) => {
                this.checkinRegistrationToken(this.env.REGION_ID, this.app?.options.projectId, token).catch((err) =>
                    console.log('Token registration failed', err)
                );
            });

            onMessage(this.messaging, (payload) => console.log(payload));
        }
    }

    getRegisterFcmSdkToken(): Observable<string> {
        return from(
            navigator.serviceWorker
                .register('firebase-messaging-sw.js', { type: 'module', scope: '__' })
                .then((registration) => {
                    const options = { serviceWorkerRegistration: registration };
                    return this.getRegistrationToken(this.messaging, options);
                })
        );
    }

    getRegistrationToken(messaging: Messaging, options?: GetTokenOptions): Promise<string> {
        return getToken(messaging, options);
    }

    addNotificationListener() {
        if (this.messaging) {
            onMessage(this.messaging, (payload) => console.log(payload));
        }
    }

    unsubscribe(): Promise<void> {
        if (this.tokenSubscription$) {
            this.tokenSubscription$.unsubscribe();
        }

        return Promise.resolve();
    }
}
